import { ResellerDto } from "@smallstack/axios-api-client";
import { BehaviorSubject } from "rxjs";

export const currentReseller$: BehaviorSubject<ResellerDto> = new BehaviorSubject<ResellerDto>(undefined);
export const currentTenantId$: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
